export const roundTo2Decimals = (num) => {
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const nToS = (value) => {
  return (value + 9).toString(36).toUpperCase();
};
